export default function AuthInterceptor($q, Auth, ENV) {
    return {
        request: function (config) {
            /*
             * API V3 utilizes a bearer token (Auth)
             */

            /**
             * Does the current request match the API url ?
             */
            if (config.url.startsWith(ENV.api)) {
                var deferred = $q.defer();

                /**
                 * Open Endpoints should not require auth
                 * custom header
                 */
                if (config.headers.endpointType == "noTokenRequired") {
                    delete config.headers.endpointType;

                    deferred.resolve(config);

                    return deferred.promise; // resolves config
                }

                /**
                 * If AccessToken is required
                 */
                Auth.getProfileToken().then(
                    (token) => {
                        if (token) {
                            config.headers.Authorization = "Bearer " + token;
                        }
                        deferred.resolve(config);
                    },
                    (err) => {}
                );

                return deferred.promise; // resolves config
            } else {
                // console.log("Legacy ");
                return config;
            }
        },
        // optional method
        requestError: function (rejection) {
            console.warn(rejection);
            // do something on error
            return $q.reject(rejection);
        },
        response: function (response) {
            //console.log(response);
            // do something on success
            return response;
        },
        responseError: function (rejection) {
            // Error handling
            if (rejection.status === 401) {
                console.warn("rejected - must be logged in");

                //localStorageService.remove('authorizationData');

                //$window.location.href = '/#/login';
                // $location.path("/login");
            }

            if (rejection.status === -1) {
                // RELOAD ID REQUEST TIMED OUT
                // $window.location.reload();

                console.warn("rejected - timeout");
            }
            return $q.reject(rejection);
        },
    };
}
